import React, { useState } from 'react'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import AdminToolbar from '../admin/components/AdminToolbar'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Box, Button, Grid2, Tooltip, Typography } from '@mui/material'
import { DateFormField } from '../../shared/components/formfields/DataFormField'
import usePayoutStore from '../../store/usePayoutStore'
import AddPayoutForm from '../admin/AddPayoutForm'
import { Constants, Input_Width } from '../../shared/constants'
import { useApartmentListForCourse, usePayoutList } from '../../assets/api/useAdminApi'
import CommonPayoutTable from './CommonPayoutTable'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { useDialog } from '../../shared/hook/useDialog'
import CustomDivider from '../../shared/utils/CustomDivider'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import EditIcon from '@mui/icons-material/Edit';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { GridActionsCellItem } from '@mui/x-data-grid'
import useAuthStore from '../../store/useAuthStore'
import { useApartmentOptions } from '../admin/option/ApartmentOption'

const CommonAddPayout = ({ id }) => {

    const [isShowPayout, setIsShowPayout] = useState(false)
    const { payoutDetail } = usePayoutStore()
    const {courseApartmentOption}=useApartmentOptions()
    const ApartmentOptions = courseApartmentOption?.options
    const [filters, setFilters] = useState({});
    const { data: payoutList, isLoading: isPayoutListLoading } = usePayoutList({ apartment_id: id, ...filters });
    const { setPayoutDetail } = usePayoutStore()
    const PayoutColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 0.5,
            renderCell: (params) => <Typography variant="body1">{params.value}</Typography>
        },
        {
            field: "course_name",
            headerName: "Course Name",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "apartment_name",
            headerName: "Apartment Name",
            width: 200,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "from_date",
            headerName: "From Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "to_date",
            headerName: "To Date",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "student_count",
            headerName: "Student Count",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "payout_type",
            headerName: "Payout Type",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "fixed_amount",
            headerName: "Amount",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "percentage",
            headerName: "Percentage",
            flex: 1.5,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },


        {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            flex: 1,
            cellClassName: "actions",
            renderCell: (params) => (
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <Tooltip title="Edit">
                        <GridActionsCellItem
                            key={0}
                            icon={<EditIcon />}
                            label="Edit"
                            onClick={() => {

                                setPayoutDetail(params.row)

                            }}
                        />
                    </Tooltip>
                </Box>
            ),
        }
    ];
    return (
        <>

            <NormalContainerWithHeader headerText={"Add Payout List"} RightContent={!(payoutDetail?.id || isShowPayout) && (

                <Button variant="outlined" onClick={() => setIsShowPayout(true)} fullWidth style={{ width: "20%" }}>Add</Button>

            )}>
                {
                    (isShowPayout || payoutDetail?.id) && <AddPayoutForm inputWidth={Input_Width} ApartmentOption={ApartmentOptions} isLoadingApart={courseApartmentOption?.isLoading} />
                }
            </NormalContainerWithHeader>
            <CustomDivider />
            <TableFilterTemplate
                title="Payout List"
                columns={PayoutColumns}
                rowsData={payoutList?.data || []}
                isLoading={isPayoutListLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}

                renderFilterFields={({ values }) => (
                    <>
                        {
                            !id && <Grid2 children size={12}>
                                <Field
                                    name="apartment_id"
                                    component={IdAutoCompleteField}
                                    options={ApartmentOptions}
                                    label="Select Apartment"
                                    maxDate={values.to_date || undefined}
                                    isLoading={courseApartmentOption?.isLoading}
                                />
                            </Grid2>
                        }

                        <Grid2 children size={12}>
                            <Field
                                name="from_date"
                                component={DateFormField}
                                label="From Date"
                                maxDate={values.to_date || undefined}

                            />
                        </Grid2>
                        <Grid2 children size={12}>
                            <Field
                                name="to_date"
                                component={DateFormField}
                                label="To Date"
                                minDate={values.from_date || undefined}

                            />
                        </Grid2>
                    </>
                )}
            />



        </>
    )
}

export default CommonAddPayout